import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import TournamentInfo from './Widgets/TournamentInfo';

const TournamentSupport = () => (
  <div id="tournament-support">
    <header className="content-header">
      <h1>
        Tournament
        <small>support</small>
      </h1>
      <ol className="breadcrumb">
        <li>
          <i className="fa fa-life-saver" /> Support
        </li>
        <li className="text-bold">
          <Link to="/tournament-support">Tournament</Link>
        </li>
      </ol>
    </header>
    <section className="content">
      <div className="row">
        <div className="col-md-12">
          <TournamentInfo />
        </div>
      </div>
    </section>
  </div>
);

export default connect(
  () => ({}),
  dispatch => ({dispatch}),
)(TournamentSupport);



// WEBPACK FOOTER //
// ./src/pages/Support/Tournament/index.js